import React from "react";
import { Project } from "../types/Project";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { Edit, Trash } from "lucide-react";
import "../styles/EmployeeList.css";

interface Props {
  projects: Project[];
  onEdit: (project: Project) => void;
  onDelete: (id: number) => void;
}

const ProjectList: React.FC<Props> = ({ projects, onEdit, onDelete }) => {
  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete details</Popover.Body>
    </Popover>
  );

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Owner</th>
          <th>Created Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {projects.map((project, index) => (
          <tr key={project.id}>
            <td>{index + 1}</td>
            <td>{project.name}</td>
            <td>{project.owner}</td>
            <td>{formatDate(project.createTimestamp)}</td>
            <td className="d-flex no-wrap border-0 justify-content-center">
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={editPopover}
              >
                <Button
                  variant="warning"
                  className="mr-2"
                  onClick={() => onEdit(project)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Edit />
                </Button>
              </OverlayTrigger>
              {/* <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={deletePopover}
              >
                <Button
                  variant="danger"
                  onClick={() => onDelete(project.id)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Trash />
                </Button>
              </OverlayTrigger> */}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProjectList;
